module.exports = __webpack_public_path__ + "img/user1.ba7ea34d.png";